import React from 'react';
import { Container, Header } from "semantic-ui-react"



const NoPage = () => {
  document.title = `tokenjobs - page not found`;
    return (
        <Container text textAlign="center">
            <Header as="h1">Page not found</Header>
        </Container>
    )
}

export default NoPage;